module.exports = __webpack_public_path__ + "static/media/SL.24e3efe2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SL.svg
// module id = 360
// module chunks = 0